module.exports = __webpack_public_path__ + "img/yt.11614fc4.svg";